export default __webpack_public_path__ + "static/media/inspection.3d11a4fa.png";